/**
 * Reserved top-level VOX routes.
 * Kept in sync with `backend/routes/cms.py:RESERVED_ROOT_SLUGS`.
 * Frontend uses this to (a) short-circuit the catch-all CMS resolver
 * and (b) warn Platform Admin at edit time. The BACKEND is the actual
 * authority — it will 409 on a reserved slug even if this list drifts.
 */
export const RESERVED_ROOT_SLUGS = new Set([
  '', 'login', 'signup', 'logout', 'auth',
  'dashboard', 'reports', 'reports-list', 'surveys', 'survey', 'responses',
  'branches', 'billing', 'settings', 'profile', 'team', 'users',
  'questions', 'reveal', 'waves', 'projects', 'competitors',
  'qa-queue', 'qa-review', 'qa-admin', 'complete-subscription',
  'past-due', 'read-only', 'archived',
  'satisfinder', 'proposal', 'public', 'demo_hotel', 'demo_restaurant',
  'sitemap.xml', 'robots.txt', 'favicon.ico', 'static', 'assets',
  'admin', 'blog',
]);

export function isReservedSlug(slug) {
  return RESERVED_ROOT_SLUGS.has((slug || '').toLowerCase());
}
